import { jsx as _jsx } from "react/jsx-runtime";
import colors from "@colors/colors";
import constants from "@utils/constants";
import { FaWaze } from "react-icons/fa";
import RoundedButton from "./roundedButton/RoundedButton";
const WazeButton = () => {
    return (_jsx(RoundedButton, { text: "Waze", backgroundColor: colors.wazePrimary, textColor: colors.white, iconColor: colors.black, icon: FaWaze, href: constants.wazeUrl }));
};
export default WazeButton;
